import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
declare var google;
@Injectable()
export class AssignmentAlgorithmService {
  constructor() { }
  assignToBranch(id,lat,lng)
  {
    firebase.database().ref("branches").orderByChild("status").equalTo("active").once("value").then((branch)=>{
      var branchList = branch.val();
      var distanceList = [];
      for(let b in branchList)
      {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(lat, lng), new google.maps.LatLng(branchList[b].lat, branchList[b].lng));
        var data = branchList[b];
        data["distance"] = distance;
        data["key"] = b;
        distanceList.push(data);
      }
      var leastDistance = distanceList[Object.keys(distanceList)[0]];
      for(let d in distanceList)
      {
        if(distanceList[d].distance <= leastDistance.distance)
        {
        leastDistance = distanceList[d];
        }
      }
      //console.log(leastDistance);
      firebase.database().ref("shipments").child(id).child("branch").set(leastDistance.key);
      });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/algorithm/assignment-algorithm.service.ts